import type { ChartOptions } from 'chart.js'
import type { RequirementStatusMap, StatusMap } from './components/types'

export const COOKIE_NAME = 'theme'

export const LOCALE_DATE_STRING_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
} as Intl.DateTimeFormatOptions

export const DOUGHNUT_CHART_OPTIONS: ChartOptions<'doughnut'> = {
  aspectRatio: 1,
  layout: {
    padding: {
      top: 5,
      bottom: 5
    }
  },
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        title: () => '',
        label (context: any) {
          return `${context.label}:  ${context.raw}`
        }
      }
    }
  },
  cutout: '50%'
}

export const STATUS_LABEL_MAP: StatusMap = {
  CANCELLED: {
    label: 'Cancelled',
    variant: 'cancelled'
  },
  CANCELLING: {
    label: 'Cancelling',
    variant: 'cancelled'
  },
  ERROR: {
    label: 'Error',
    variant: 'error'
  },
  FAILED: {
    label: 'Failed',
    variant: 'fail'
  },
  PENDING: {
    label: 'Pending',
    variant: 'pending'
  },
  STARTED: {
    label: 'In Progress',
    variant: 'inProgress'
  },
  RUNNING: {
    label: 'In Progress',
    variant: 'inProgress'
  },
  INCOMPLETE: {
    label: 'In Progress',
    variant: 'inProgress'
  },
  SUCCESS: {
    label: 'Passed',
    variant: 'pass'
  },
  SUCCESS_AFTER_RERUN: {
    label: 'Passed After Rerun',
    variant: 'passAfterRerun'
  },
  PASSED: {
    label: 'Passed',
    variant: 'pass'
  },
  UNTESTED: {
    label: 'Untested',
    variant: 'untested'
  },
  SKIPPED: {
    label: 'Skipped',
    variant: 'skipped'
  }
}

export const REQUIREMENT_STATUS_LABEL_MAP: RequirementStatusMap = {
  VERIFIED: {
    label: 'Verified',
    variant: 'verified'
  },
  UNSUCCESSFUL: {
    label: 'Unsuccessful',
    variant: 'unsuccessful'
  },
  UNTESTED: {
    label: 'Untested',
    variant: 'untested'
  },
  UNASSIGNED: {
    label: 'Unassigned',
    variant: 'unassigned'
  },
  IN_PROGRESS: {
    label: 'In progress',
    variant: 'inProgress'
  },
  PASSED: {
    label: 'Passed',
    variant: 'pass'
  },
  FAILED: {
    label: 'Failed',
    variant: 'fail'
  },
  CANCELLED: {
    label: 'Cancelled',
    variant: 'cancelled'
  },
  ERROR: {
    label: 'Error',
    variant: 'error'
  }
}
